import React from 'react';
import './styles.scss';
import pitch from './assets/pitch.svg';
import hunter from './assets/hunter.svg';
import slite from './assets/slite.svg';
import ipinfo from './assets/ipinfo.svg';
import helpdocs from './assets/helpdocs.svg';
import weglot from './assets/weglot.svg';
import refiner from './assets/refiner.svg';
import proposales from './assets/proposales.svg';
import beatport from './assets/beatport.svg';
import ef from './assets/ef.svg';

import docstation from './assets/docstation.svg';
import alma from './assets/alma.svg';
import laddition from './assets/laddition.svg';
import contra from './assets/contra.svg';
import republiquefrancaise from './assets/republiquefrancaise.svg';
import medianetwork from './assets/medianetwork.svg';
import rankz from './assets/rankz.svg';
import thanx from './assets/thanx.svg';
import october from './assets/october.svg';
import scrapingbee from './assets/scrapingbee2.svg';
import fellow from './assets/fellow.svg';
import rightarrow from './right-arrow.svg';

const Companies = ({ headline = 'Trusted by companies of all sizes and industries' }) => {
  return (
    <section className="home-companies">
      <div className="home-companies-content">
        <h2>{headline}</h2>
          <div className="home-companies-logos">
            <a target="_blank" href="https://beta.gouv.fr" className="flex justify-content-center"><img src={republiquefrancaise} className="republique" height="78" /></a>
            <a target="_blank" href="https://laddition.com"><img src={laddition} height="22px" style={{marginTop: '8px'}} /></a>
            <a target="_blank" href="https://pitch.com"><img src={pitch} height="26px" style={{marginTop: '1px'}} /></a>
            <a target="_blank" href="https://contra.com"><img src={contra} height="22px" style={{marginTop: '9px'}} /></a>
            <a target="_blank" href="https://beatport.com"><img src={beatport} height="38" style={{marginTop: '2px'}} /></a>
            <a target="_blank" href="https://getalma.eu"><img src={alma} height="38px" style={{marginTop: '18px'}} /></a>
            <a target="_blank" href="https://slite.com"><img src={slite} height="24px" style={{marginTop: '2px'}} /></a>
            <a target="_blank" href="https://october.eu"><img src={october} height="24px"style={{marginTop: '9px'}} /></a>
            <a target="_blank" href="https://ipinfo.io"><img src={ipinfo} height="32px" style={{marginTop: '1px'}} /></a>
            <a target="_blank" href="https://refiner.io"><img src={refiner} height="20px" style={{marginTop: '-2px'}} /></a>
            <a target="_blank" href="https://docstation.co"><img src={docstation} height="20px" style={{marginTop: '3px'}} /></a>
            <a target="_blank" href="https://www.ef.com"><img src={ef} height="38px" style={{marginTop: '-1px'}} /></a>
            <a target="_blank" href="https://helpdocs.io"><img src={helpdocs} height="30px" style={{marginTop: '6px'}} /></a>
            <a target="_blank" href="https://scrapingbee.com"><img src={scrapingbee} height="40px" /></a>
            <a target="_blank" href="https://fellow.app"><img src={fellow} height="24px" style={{marginTop: '-2px'}} /></a>
            <a target="_blank" href="https://proposales.com"><img src={proposales} height="26px" style={{marginTop: '1px'}} /></a>
          </div>
          {/* <div className="read-customer-stories"><a href="/customers">Read stories <img src={rightarrow} /></a></div> */}
      </div>
    </section>
  );
};

export default Companies;
